import { orderBy } from 'lodash';
import React from 'react';
import { useFormContext } from 'react-hook-form';
import { useResponsive } from 'src/hooks/use-responsive';
import { CartItemDTO } from 'src/types';

import { CurrencyCodes } from '../../types/users/currency';
import TicketAvailable from './ticket-available';
import TicketSoldOut from './ticket-sold-out';

type TicketProps = {
  handleIncrease: (field: any, index: number) => void;
  handleDecrease: (field: any, index: number) => void;
  currency?: CurrencyCodes;
};

const TicketItem = ({ handleIncrease, handleDecrease, currency }: TicketProps) => {
  const { watch, control } = useFormContext();
  const tickets = watch('tickets') as CartItemDTO[];
  const mdUp = useResponsive('up', 'md');

  return (
    <>
      {orderBy(tickets, 'price', 'asc')?.map((ticket, index) =>
        ticket.quantityLeft > 0 ? (
          <TicketAvailable
            key={index}
            ticket={ticket}
            index={index}
            control={control}
            currency={currency}
            handleIncrease={handleIncrease}
            handleDecrease={handleDecrease}
            mdUp={mdUp}
          />
        ) : (
          <TicketSoldOut key={index} ticket={ticket} currency={currency} />
        )
      )}
    </>
  );
};

export default TicketItem;
